import React from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { RootState } from '../../store/rootReducer'
import { analyzeAndSign, clearError } from '../signing/ovscSlice'
import { UploadAndErrors} from '../upload/UploadAndErrors'
import { setFiles, reset} from '../upload/dropZoneSlice'
import ContentLayout  from '../layout/ContentLayout'

import './index.css';
import "react-client-captcha/dist/index.css"

   

const AnalyzeAndSign:React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  

  const { inSignCall, errorResult } = useSelector(
    (state: RootState) => state.ovsc, shallowEqual
  )
  const { files } =   useSelector((state: RootState) => state.dropZone) 
  
  

  let dimmerText:string=""
  if (inSignCall)
  {
    dimmerText=t("sign.wait")
  }
  
  

  return <ContentLayout>
    <div>{t("sign.description")}</div>
    
    
      
      

    <UploadAndErrors inputFiles={files} 
      onChange={ (f) => { dispatch(setFiles(f)); dispatch(clearError()) } }
      uploadButtonCaption={t("sign.upload")}  
      cancelButtonCaption={t("sign.cancel")} 
      handleReset={ () => {dispatch(reset()); dispatch(clearError())}} 
      handleUpload={() => {dispatch(clearError()); dispatch(analyzeAndSign(files[0])) }}
      errorResult = {errorResult}
      dimmerText={dimmerText} />
      
  </ContentLayout>

}

export default AnalyzeAndSign;